import React from 'react';
import AllShop from '../component/shop/allShop';

const ShopPage = () => {
  return (
    <>
      <AllShop />
    </>
  );
};

export default ShopPage;
